<hr>
<h2>Add Invoice</h2><button class="cancel btn btn-warning" (click)="goBack()">Cancel</button>
<hr>
<div >
    <form [formGroup]="myForm" (ngSubmit)="addInvoice()" novalidate>
       <div class="form-group" >
            @if (myForm.get('customercode')?.invalid) {
                @if (customercode?.errors?.['maxlength']) {
                    <div class="help-block">
                        Customer Code has too many characters.
                    </div>
                }
                @if (customercode?.errors?.['required']) {
                    <div class="help-block">
                        Customer Code is required.
                    </div>
                }
            }            
            <label for="customercode">Customer Code</label>
            <select id="customercode"  formControlName="customercode" required >
                @for (customercode of customercodes; track customercode.customercode) {
                    <option value = {{customercode.customercode}}>{{customercode.customername}}</option>
                }
            </select>
        </div>
        <div class="form-group" >
            @if (myForm.get('productcode')?.invalid) {
                    @if (productcode?.errors?.['maxlength']) {
                        <div class="help-block">
                            Product Code has too many characters.
                        </div>
                    }
                    @if (productcode?.errors?.['required']) {
                        <div class="help-block">
                            Product Code is required.
                        </div>
                    }
                }            
                <label for="productcode">Product Code</label>
                <select id="productcode" formControlName="productcode"  required >
                    @for (product of productcodes; track product.productcode) {
                        <option value={{product.productcode}}>{{product.description}}</option>
                    }
                </select>
        </div>
        <div class="form-group" >
               @if (myForm.get('employeecode')?.invalid) {
                    @if (employeecode?.errors?.['maxlength']) {
                        <div class="help-block">
                            Employee Code has too many characters.
                        </div>
                    }
                    @if (employeecode?.errors?.['required']) {
                        <div class="help-block">
                            Employee Code is required.
                        </div>
                    }
                }            
                <label for="employeecode">Employee Code</label>
                <select id="employeecode" formControlName="employeecode" required >
                    @for (employeecode of employeecodes; track employeecode.employeecode) {
                        <option value={{employeecode.employeecode}}>{{employeecode.fname + ' ' + employeecode.lname}}</option>
                    }
                    </select>
        </div>
        <div class="form-group" >
            <label for="shiptoaddressserial">Ship To Address Serial (optional, default will be 1)</label>
            @if (myForm.get('shiptoaddressserial')?.invalid) {
                <div class="help-block">
                    Value must be a Number.
                </div>
            }         
            <input type="text" class="form-control" id="shiptoaddressserial" formControlName="shiptoaddressserial"/>
        </div>
        <div class="form-group" >
            <label for="invoiceno">Invoice No</label>
            @if (myForm.get('invoiceno')?.invalid) {
                @if (invoiceno?.errors?.['maxlength']) {
                    <div class="help-block">
                        Invoice No has too many characters.
                    </div>
                }
                @if (invoiceno?.errors?.['required']) {
                    <div class="help-block">
                        Invoice No is required.
                    </div>
                }
            }                            
            <input type="text" class="form-control" id="invoiceno" formControlName="invoiceno" required />
        </div>
        <div class="form-group" >
                <label for="invoicedate">Invoice Date</label>
                @if (myForm.get('invoicedate')?.invalid) {
                    @if (invoicedate?.errors?.['required']) {
                        <div class="help-block">
                            Invoice Date is required.
                        </div>
                    }
                    @if (invoicedate?.errors?.['maxlength']) {
                        <div class="help-block">
                            Invoice Date has too many characters.
                        </div>
                    }
                    @if (invoicedate?.errors?.['pattern']) {
                        <div class="help-block">
                            Invoice Date must use this pattern MM/DD/YYYY.
                        </div>
                    }
                }              
                <input type="date" class="form-control" id="invoicedate" formControlName="invoicedate" required />
        </div>
        <div class="form-group" >
             @if (myForm.get('warehousecode')?.invalid) {
                @if (warehousecode?.errors?.['maxlength']) {
                    <div class="help-block">
                        Warehouse Code has too many characters.
                    </div>
                }
                @if (warehousecode?.errors?.['required']) {
                    <div class="help-block">
                        Warehouse Code is required.
                    </div>
                }
            }
            <label for="warehousecode">Warehouse Code</label>
            <select id="warehousecode" formControlName="warehousecode" required >
                @for (warehousecode of warehousecodes; track warehousecode.warehousecode) {
                    <option value={{warehousecode.warehousecode}}>{{warehousecode.description}}</option>
                }
            </select>
        </div>
        <div class="form-group" >
            <label for="schemecode">Scheme Code (optional)</label>
            @if (myForm.get('schemecode')?.invalid) {
                @if (schemecode?.errors?.['maxlength']) {
                    <div class="help-block">
                        Scheme Code has too many characters.
                    </div>
                }
            }
            <input type="text" class="form-control" id="schemecode" formControlName="schemecode"/>
        </div>
        <div class="form-group" >
            <label for="volumesold">Volume Sold</label>
            @if (myForm.get('volumesold')?.invalid) {
                @if (volumesold?.errors?.['required']) {
                    <div class="help-block">
                            Volume Sold is required.
                    </div>
                }
                @if (volumesold?.errors?.['invalid']) {
                    <div class="help-block">
                        Volume Sold must be a decimal (0.0000).
                    </div>
                }
            }         
            <input type="text" class="form-control" id="volumesold" formControlName="volumesold" required/>
        </div> 
        <div class="form-group" >
            @if (myForm.get('volumeid')?.invalid) {
                @if (volumeid?.errors?.['required']) {
                        <div class="help-block">
                            Volume ID is required.
                        </div>
                }
                @if (volumeid?.errors?.['maxlength']) {
                        <div class="help-block">
                            Volume ID has too many characters.
                        </div>
                }

            }
            <label for="volumeid">Volume Identifier</label>
            <select formControlName="volumeid" id="volumeid"required>
                                <option value="B">Base Unit of Measure</option>
                                <option value="L">Litre</option>
                                <option value="P">Pack</option>
                                <option value="C">Case</option>
            </select>
        </div> 
        <div class="form-group" >
            <label for="grossturnover">Gross Turn Over (Volume * Sales Price before discount)</label>
            @if (myForm.get('grossturnover')?.invalid) {
                @if (grossturnover?.errors?.['required']) {
                        <div class="help-block">
                            Gross Turn Over is required.
                        </div>
                }
                @if (grossturnover?.errors?.['pattern']) {
                        <div class="help-block">
                            Gross Turn Over must be a decimal (0.0000).
                        </div>
                }

            }                
            <input type="text" class="form-control" id = "grossturnover" formControlName="grossturnover" required/>
        </div> 
        <div class="form-group" >
            <label for="cogs">COGS (Volume * COST)</label>
            @if (myForm.get('cogs')?.invalid) {
                @if (cogs?.errors?.['required']) {
                        <div class="help-block">
                            COGS is required.
                        </div>
                }
                @if (cogs?.errors?.['pattern']) {
                        <div class="help-block">
                            COGS has too many characters.
                        </div>
                }

            } 
            <input type="text" class="form-control" id="cogs" formControlName="cogs" required/>
        </div> 
        <div class="form-group" >
            @if (myForm.get('producttype')?.invalid) {
                <div class="help-block">
                    Value must be a Number.
                </div>
            }         
            <label for="producttype">Product Type (optional)</label>
            @if (myForm.get('producttype')?.invalid) {
                <div class="help-block">
                    Value can only be 1 character.
                </div>
            }         
            <select name="producttype" formControlName="producttype" id="producttype">
                    <option value="I">Inventory</option>
                    <option value="N">Non-Inventory</option>
            </select>
        </div>
        <div class="form-group" >
               <label for="lineno">Line Number (optional)</label>
                @if (myForm.get('lineno')?.invalid) {
                    @if (lineno?.errors?.['maxlength']) {
                        <div class="help-block">
                            Line No has too many characters.
                        </div>
                    }
                    @if (lineno?.errors?.['min']) {
                        <div class="help-block">
                            Line No must be a positive number.
                        </div>
                    }
                }
                <input type="text" class="form-control" id="lineno" formControlName="lineno" />
        </div> 
        <div class="form-group">
                <label for="customerpo">Customer PO (optional)</label>
                @if (myForm.get('customerpo')?.invalid) {
                    @if (customerpo?.errors?.['maxlength']) {
                        <div class="help-block">
                            Customer PO has too many characters.
                        </div>
                    }
                }
            <input type="text" class="form-control" id="customerpo" formControlName="customerpo"/>
        </div>
        <div class="form-group" >
                 <label for="discount">Discount (optional, NOT a percentage)</label>
                @if (myForm.get('discount')?.invalid) {
                        <div class="help-block">
                            Discount must be > 0.
                        </div>
                }            
                <input type="text" class="form-control" id="discount" formControlName="discount"/>
        </div>
        <div class="form-group" >
                <label for="creationdate">Creation Date (optional)</label>
                @if (myForm.get('modifieddate')?.invalid) {
                    @if (creationdate?.errors?.['pattern']) {
                        <div class="help-block">
                            Creation Date must use this pattern: MM/DD/YYYY.
                        </div>
                    }
                }
                <input type="date" class="form-control" id="creationdate" formControlName="creationdate" />
        </div>
        <div class="form-group">
                <label for="modifieddate">Modified Date (optional)</label>
                @if (myForm.get('modifieddate')?.invalid) {
                    @if (modifieddate?.errors?.['pattern']) {
                        <div class="help-block">
                            Modified Date must use this pattern: MM/DD/YYYY.
                        </div>
                    }
                }
                <input type="date" class="form-control" id="modifieddate" formControlName="modifieddate" />
        </div>
        <div class="form-group">
                 <label for="netturnover">Net Turn Over (Volume * Sales Price after discount)</label>
                @if (myForm.get('netturnover')?.invalid) {
                    @if (netturnover?.errors?.['required']) {
                        <div class="help-block">
                            Net Turn Over is required.
                        </div>
                    }
                    @if (netturnover?.errors?.['pattern']) {
                        <div class="help-block">
                            Net Turn Over must be a number.
                        </div>
                    }

                }
                <input type="text" class="form-control" id="netturnover" formControlName="netturnover" required/>
        </div> 
        <div class="form-group" >
               <label for="supplierorderno">Supplier Order No (optional)</label>
                @if (myForm.get('supplierorderno')?.invalid) {
                <div class="help-block">
                    Supplier Order No has too many characters.
                </div>
            }         
            <input type="text" class="form-control" id="supplierorderno" formControlName="supplierorderno"/>
        </div>
        <div class="form-group" >
                 <label for="orderdate">Order Date (optional)</label>
                <input type="date" class="form-control" id="orderdate" formControlName="orderdate"  />
                @if (myForm.get('orderdate')?.invalid) {
                    @if (orderdate?.errors?.['pattern']) {
                        <div class="help-block">
                            Order Date must use this pattern: MM/DD/YYYY.
                        </div>
                    }
                }
        </div>
        <div class="form-group" >
                <label for="deliverynoteno">Delivery Note No (optional)</label>
                @if (myForm.get('deliverynoteno')?.invalid) {
                <div class="help-block">
                    Value must be less than 30 characters.
                </div>
            }         
                <input type="text" class="form-control" id="deliverynoteno" formControlName="deliverynoteno" />
        </div>
        <div class="form-group" >
               <label for="deliverynotedate">Delivery Note Date (optional)</label>
                @if (myForm.get('deliverynotedate')?.invalid) {
                    @if (deliverynotedate?.errors?.['pattern']) {
                        <div class="help-block">
                            Delivery Note Date must use this pattern: MM/DD/YYYY.
                        </div>
                    }
                }                     
                <input type="date" class="form-control" id="deliverynotedate" formControlName="deliverynotedate" />
                
        </div>
       <div class="form-group" >
                <label for="retaildealerid">Retail Dealer No (optional)</label>
                @if (myForm.get('retaildealerid')?.invalid) {
                    @if (retaildealerid?.errors?.['maxlength']) {
                        <div class="help-block">
                           Retail Dealer has too many characters.
                        </div>
                    }
                }
                <input type="text" class="form-control" id="retaildealerid" formControlName="retaildealerid"/>
        </div>
        <div class="form-group" >
                <label for="refinvoicenocredit">Ref. Invoice No. for Credit (optional)</label>
                @if (myForm.get('refinvoicenocredit')?.invalid) {
                    @if (refinvoicenocredit?.errors?.['maxlength']) {
                        <div class="help-block">
                           Ref. Invoice No. for Credit has too many characters.
                        </div>
                    }
                }
                <input type="text" class="form-control" id="refinvoicenocredit" formControlName="refinvoicenocredit"/>
        </div>
        <div class="form-group">
                <label for="reflinenocreditnote">Ref. Line No. for Credit Note (optional)</label>
                @if (myForm.get('reflinenocreditnote')?.invalid) {
                    @if (reflinenocreditnote?.errors?.['maxlength']) {
                        <div class="help-block">
                           Ref. Line No. for Credit Note has too many characters.
                        </div>
                    }
                }
                <input type="text" class="form-control" id="reflinenocreditnote" formControlName="reflinenocreditnote"/>
        </div>


        <div class="form-group">
            <button type="submit" [disabled]="myForm.invalid" class="btn btn-primary">Add</button>
        </div>
    </form>
    
</div>
